import { Route } from '@angular/router';

export default {
  path: '**',
  loadComponent: () =>
    import('@app/src/app/modules/not-found/views/public/not-found/not-found').then(
      (m) => m.NotFound,
    ),
  data: {
    title: 'Not Found',
  },
} as Route;
